import { useState, useEffect } from "react";
import FormArr from "../../form-arr";
import service from "../../../utils/service";
import { connect } from "react-redux";
import { withRouter, useLocation, useHistory } from "react-router-dom";
import _ from "lodash";
import Switch from "react-switch";
import { toast } from "react-toastify";
import Loader from "react-loaders";
// import { showModal } from '../../../actions/modalActions/modalActions';
import { useSelector } from "react-redux";

const OffCanvasCreateAlert = (props) => {
  const { partyDetail, cb } = props;
  const [signalInfo, setSignalInfo] = useState([]);
  const [show, setShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const [alertLoader, setAlertLoader] = useState("");
  const history = useHistory();
  const isVisible = useSelector((state) => state.my_profile.my_org.status);
  // const statusvalue = isVisible === "active" ? true : false;
  // const dispatch = useDispatch();

  const triggerSignalsAPI = async (partyObj) => {
    const party_id =
      _.get(partyObj, "party.party_id") ||
      _.get(partyObj, "party.registered_address.party_id");

    if (!party_id) return;

    try {
      const res = await service.get(
        `v4/filters/parties/${party_id}/signal_dropdown`
      );
      setSignalInfo(res?.data?.results || []);
    } catch (error) {
      console.error("Error fetching signal info:", error);
    }
  };

  useEffect(() => {
    if (partyDetail) {
      triggerSignalsAPI({
        party: _.get(partyDetail, "data"),
      });
    }
  }, [partyDetail]);

  const convertJsonToOptions = () => {
    if (!Array.isArray(signalInfo)) {
      return [];
    }
    return signalInfo.map((code) => ({
      value: `${code.id}`,
      label: `${code.text}`,
    }));
  };



  const trigger_postAPI = async (obj) => {
    setAlertLoader("loading");
    const party_id = _.get(obj, "party.party_id") || _.get(partyDetail, "data.registered_address.party_id")
    const signal_code = _.get(obj, "signal_code.value");
    const risk_severity = _.get(obj, "risk_severity.value");
    const alert_description = _.get(obj, "alert_description");
    const date_of_event = _.get(obj, "date_of_event");
    // const create_ticket = checked;
    if (party_id && signal_code && risk_severity && alert_description && date_of_event) {
      const payload = {
        party_id,
        signal_code,
        risk_severity,
        alert_description,
        date_of_event
      };
      try {
        const res = await service.post("v4/alerts", payload);

        if (res.status === 200) {
          toast.success("Alert Created Successfully");
          setAlertLoader("done");
          handleCloseOffcanvas();
          cb && cb();
        } else {
          toast.error(res?.data?.message || "Error occurred while creating alert");
          setAlertLoader("error");
        }
      } catch (error) {
        toast.error("Something went wrong");
        setAlertLoader("error");
      }
    }
  };


  const actionButtons = [
    {
      label: "Create",
      class: "btn btn-primary btn-sm",
      type: "submit-form",
      action: trigger_postAPI,
    },
  ];

  const getDefaultValuesAndSearchArr = () => {
    let defaultValueObj = {};
    let searchArr = [];

    defaultValueObj = {
      ...defaultValueObj,
      date_of_event: new Date().toISOString().split("T")[0],
    };

    if (partyDetail) {
      defaultValueObj = {
        ...defaultValueObj,
        party: _.get(partyDetail, "data.name"),
      };

      searchArr.push({
        label: "Party Name",
        key: "party",
        mandatory: true,
        disabled: true,
        component: "input",
      });
    } else {
      searchArr.push({
        label: "Party Name",
        key: "party",
        mandatory: true,
        component: "search",
        selectOption: (id, s_obj) => {
          const obj = {
            party: s_obj
          };

          triggerSignalsAPI(obj);
        }
      });
    }

    return { defaultValueObj, searchArr };
  };


  const { defaultValueObj, searchArr } = getDefaultValuesAndSearchArr();

  const formArr = [
    {
      label: "Select Signal/Summary",
      key: "signal_code",
      component: "dropdown",
      mandatory: true,
      option: convertJsonToOptions(),
    },
    {
      label: "Risk Severity ",
      key: "risk_severity",
      component: "dropdown",
      mandatory: true,
      option: [
        {
          value: "high",
          label: "High",
        },
        {
          value: "medium",
          label: "Medium",
        },
        {
          value: "low",
          label: "Low",
        },
      ],
    },
    {
      label: "Alert Description",
      key: "alert_description",
      type: "text",
      component: "input",
      mandatory: true,
    },

    {
      label: "Date Of Event",
      key: "date_of_event",
      component: "date",
      mandatory: true,
      max: new Date().toISOString().split("T")[0],
    },
  ];

  const handleChange = (checked) => {
    setChecked(checked);
  };
  const get_recurring_case_ui = () => {
    return (
      <div className="row mt-3">
        <label className="col-md-5 col-12 col-form-label ">
          Force Trigger Case
        </label>
        <div className="col-md-7 col-12 mt-2">
          <Switch checked={checked} onChange={handleChange} />
        </div>
      </div>
    );
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const offCanvas = queryParams.get("offCanvas");
  useEffect(() => {
    if (offCanvas) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [offCanvas]);
  const handleCloseOffcanvas = () => {
    queryParams.delete("offCanvas");
    history.push({ search: queryParams.toString() });
  };
  return (
    <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
      <div className="offcanvas-header">
        <i className="create-case me-2" />
        <h5 className="offcanvas-title" id="offcanvasRightLabel"> Create Alert</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={handleCloseOffcanvas}
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="p-3 mobile-only-scroll">
          {alertLoader === "loading" ? (
            <div className="text-center">
              <Loader type="line-scale" />
            </div>
          ) : (
            <FormArr
              form_fields={[...searchArr, ...formArr]}
              defaultValueObj={defaultValueObj}
              action_buttons={actionButtons}
            >
              {/* {get_recurring_case_ui()} */}
            </FormArr>
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  partyDetail: _.get(state, "party.information.result.data"),
});

export default connect(mapStateToProps)(withRouter(OffCanvasCreateAlert));
